import cn from 'classnames';
import { ReactNode } from 'react';

import styles from './Avatar.module.scss';

type AvatarGroupProps = {
  children?: ReactNode;
  className?: string;
  testID?: string;
};

export const AvatarGroup = ({
  children,
  className,
  testID,
}: AvatarGroupProps) => (
  <div className={cn(styles.avatarGroup, className)} data-testid={testID}>
    {children}
  </div>
);
